module.exports = __webpack_public_path__ + "img/3.f82b8c9b.png";